module.exports = __webpack_public_path__ + "media/images/boxes/aktien-532559ea908dfe6bf3b5d0fd2bd2a02f.jpg";